import enumToArray from "@irati/utils/enumToArray"

enum StatementItemTypes {
  // cash wallets, leave be
  PERKS_GO_CASHBACK = "cashback",
  SEND_CREDIT_AS_REWARD = "send-credit-as-reward",
  USE_CREDIT_TO_BUY_REWARD = "use-credit-to-buy-reward",
  TRANSFER_TO_REWARDS_WALLET = "transfer-to-rewards-wallet",
  TOP_UP_BANK_TRANSFER = "tenant-wallet-topup-bank-transfer",
  TOP_UP_CARD_PAYMENT = "tenant-wallet-topup-card-payment",
  NEW_TOP_UP_BANK_TRANSFER = "wallet-topup-bank-transfer",
  NEW_TOP_UP_CARD_PAYMENT = "wallet-topup-card-payment",
  REFUND_FROM_REWARDS_WALLET = "refund-from-rewards-wallet",
  SEND_CREDIT_AS_REWARD_REFUND = "send-credit-as-reward-refund",
  // flexi points
  SEND_CREDIT = "SEND_CREDIT",
  SPEND = "SPEND_CREDIT",
  TOPUP = "TOPUP",
  TRANSFER = "TRANSFER",
  MANUAL_TRANSFER = "MANUAL_TRANSFER",
  REWARD = "REWARD",
  // special
  BE_SIMPLE_STATEMENT = "BE_SIMPLE_STATEMENT"
}

export const knownStatementItemTypes = enumToArray(StatementItemTypes)

export default StatementItemTypes
